import gqlRequest from "@biuwer/core/src/graphql-request";
import { defaultContext } from "../../config/constants";
import { addNotification } from "../notifications/notifications-actions";
import Auth from "@biuwer/redux/src/system/auth/auth-lib";
import { HOME_PRODUCT_UPDATES } from "./home-gql";


/**
 * Action types
 */
export const HOME_INITIALIZE = "HOME_INITIALIZE";
export const HOME_PRODUCT_UPDATES_INITIALIZE = "HOME_PRODUCT_UPDATES_INITIALIZE";

export const HOME_PRODUCT_UPDATES_FETCH_REQUEST = "HOME_PRODUCT_UPDATES_FETCH_REQUEST";
export const HOME_PRODUCT_UPDATES_FETCH_SUCCESS = "HOME_PRODUCT_UPDATES_FETCH_SUCCESS";
export const HOME_PRODUCT_UPDATES_FETCH_ERROR = "HOME_PRODUCT_UPDATES_FETCH_ERROR";


function generateSkeleton(type, body, context = defaultContext, showNotification = true) {
    let skeleton = { type, context };
    let notification;

    const typeSuffix = type.substring(type.lastIndexOf("_") + 1);

    switch (typeSuffix) {
        case "REQUEST":
            skeleton = { ...skeleton, isFetching: true, issue: false };
            break;
        case "ERROR":
            skeleton = {
                ...skeleton,
                isFetching: false,
                issue: true,
                issuePayload: {
                    status: body.status,
                    code: body.statusCode,
                    message: body.message
                }
            };
            break;
        case "SUCCESS":
            skeleton = {
                ...skeleton,
                isFetching: false,
                issue: body.status === 2,
                payload: body
            };

            if (body.status === 2) {
                skeleton.issuePayload = {
                    status: body.status,
                    code: body.issuePayload?.code,
                    message: body.message
                };
            }
            break;
        default:
            break;
    }

    return (dispatch) => {
        dispatch(skeleton);
        if (notification && showNotification) {
            dispatch(addNotification(notification));
        }
    };
}

/**
 * Initialization actions
 */
export const initializeHome = (context = defaultContext) => ({
    type: HOME_INITIALIZE,
    context
});

export const initializeHomeProductUpdates = (context = defaultContext) => ({
    type: HOME_PRODUCT_UPDATES_INITIALIZE,
    context
});

/**
 * Get product updates action
 * Fetches all product updates for all locales (en, es)
 */
export const getProductUpdates = (context = defaultContext, gql = HOME_PRODUCT_UPDATES) => {
    return async (dispatch) => {
        dispatch(generateSkeleton(HOME_PRODUCT_UPDATES_FETCH_REQUEST, null, context));

        try {
            const response = await gqlRequest({
                queryName: "getProductUpdates",
                queryGql: gql,
                token: Auth.getLocalJwt(),
                variables: []
            });
            
            dispatch(generateSkeleton(HOME_PRODUCT_UPDATES_FETCH_SUCCESS, response, context));
        } catch (err) {
            dispatch(generateSkeleton(HOME_PRODUCT_UPDATES_FETCH_ERROR, err, context));
        }
    };
};
